import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { noop } from 'lodash';
import { isDecodedStackTraceEnabledSelector } from '@store/common/selectors';
import { APP_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import { useAppMultiDimensions } from './useAppMultiDimensions';
import { unitAtom } from '@components/metrics-panel-hz/atoms';

export const STACK_TRACE_DIMENSIONS = [
  APP_DIMENSIONS.APP_ID,
  APP_DIMENSIONS.PLATFORM,
  APP_DIMENSIONS.APPLICATION_VERSION,
];

// Check if the decoded stack trace is allowed to be enabled
export const useIsDecodedStackTraceEnabled = () => {
  const isEnabled = useSelector(isDecodedStackTraceEnabledSelector);
  return Boolean(isEnabled);
};

export const useDimensions = (dimension: string) => {
  const isDecodedStackTraceEnabled = useIsDecodedStackTraceEnabled();

  const dimensions = useMemo(() => {
    const targetDimensions = isDecodedStackTraceEnabled
      ? [dimension, ...STACK_TRACE_DIMENSIONS]
      : [dimension];
    return targetDimensions;
  }, [dimension, isDecodedStackTraceEnabled]);

  return dimensions;
};

export const useFormattedData = ({ enableFetchData, dimensions, defaultData }) => {
  const unit = useAtomValue(unitAtom);
  const { data, isFetching, isError, isEmpty, refetch } = useAppMultiDimensions({
    dimensions,
    unit,
    enabled: enableFetchData,
  });

  if (enableFetchData) {
    return {
      data,
      isFetching,
      isEmpty,
      isError,
      refetch,
    };
  } else {
    return {
      data: defaultData,
      isFetching: false,
      isEmpty: false,
      isError: false,
      refetch: noop,
    };
  }
};
